import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { SERVICE_TICKET_OVERLAY_IT } from './service-ticket';
import { ServiceTicketOverlayComponent } from './service-ticket-overlay/service-ticket-overlay.component';

@Injectable({
  providedIn: 'root',
})
export class ServiceTicketService {
  private overlayRef = null;
  private componentPortalRef = null;

  constructor(private overlay: Overlay) {
    this.overlayRef = this.overlay.create({
      width: '100vw',
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });
  }

  openOverlay(): void {
    const overlayInjector = Injector.create({
      providers: [{ provide: SERVICE_TICKET_OVERLAY_IT, useValue: this.overlayRef }],
    });

    this.componentPortalRef = new ComponentPortal(
      ServiceTicketOverlayComponent,
      null,
      overlayInjector
    );
    this.overlayRef.attach(this.componentPortalRef);
  }
}
